var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarSolidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F5F8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1249 10.1328H21.4999V11.1995H22.9999V22.9328H9.00011V11.1995H10.5001V10.1328H8.87511C8.75823 10.1349 8.64289 10.1615 8.53565 10.2112C8.42842 10.2608 8.33141 10.3325 8.25016 10.4221C8.1689 10.5118 8.105 10.6176 8.0621 10.7336C8.0192 10.8496 7.99814 10.9735 8.00013 11.0981V23.0341C7.99814 23.1588 8.0192 23.2827 8.0621 23.3987C8.105 23.5147 8.1689 23.6205 8.25016 23.7102C8.33141 23.7998 8.42842 23.8715 8.53565 23.9211C8.64289 23.9708 8.75823 23.9974 8.87511 23.9995H23.1249C23.2418 23.9974 23.3571 23.9708 23.4643 23.9211C23.5716 23.8715 23.6686 23.7998 23.7498 23.7102C23.8311 23.6205 23.895 23.5147 23.9379 23.3987C23.9808 23.2827 24.0019 23.1588 23.9999 23.0341V11.0981C24.0019 10.9735 23.9808 10.8496 23.9379 10.7336C23.895 10.6176 23.8311 10.5118 23.7498 10.4221C23.6686 10.3325 23.5716 10.2608 23.4643 10.2112C23.3571 10.1615 23.2418 10.1349 23.1249 10.1328Z",
    fill: "#8898A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.4004H12V15.4671H11V14.4004Z",
    fill: "#8898A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 14.4004H15V15.4671H14V14.4004Z",
    fill: "#8898A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14.4004H18V15.4671H17V14.4004Z",
    fill: "#8898A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.4004H21V15.4671H20V14.4004Z",
    fill: "#8898A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.0664H12V18.1331H11V17.0664Z",
    fill: "#8898A6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17.0664H15V18.1331H14V17.0664Z",
    fill: "#8898A6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.0664H18V18.1331H17V17.0664Z",
    fill: "#8898A6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.0664H21V18.1331H20V17.0664Z",
    fill: "#8898A6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.7344H12V20.801H11V19.7344Z",
    fill: "#8898A6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19.7344H15V20.801H14V19.7344Z",
    fill: "#8898A6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19.7344H18V20.801H17V19.7344Z",
    fill: "#8898A6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19.7344H21V20.801H20V19.7344Z",
    fill: "#8898A6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.2667C12.1326 12.2667 12.2598 12.2105 12.3535 12.1105C12.4473 12.0104 12.5 11.8748 12.5 11.7333V8.53333C12.5 8.39188 12.4473 8.25623 12.3535 8.15621C12.2598 8.05619 12.1326 8 12 8C11.8674 8 11.7402 8.05619 11.6464 8.15621C11.5527 8.25623 11.5 8.39188 11.5 8.53333V11.7333C11.5 11.8748 11.5527 12.0104 11.6464 12.1105C11.7402 12.2105 11.8674 12.2667 12 12.2667Z",
    fill: "#8898A6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.2667C20.1326 12.2667 20.2598 12.2105 20.3535 12.1105C20.4473 12.0104 20.5 11.8748 20.5 11.7333V8.53333C20.5 8.39188 20.4473 8.25623 20.3535 8.15621C20.2598 8.05619 20.1326 8 20 8C19.8674 8 19.7402 8.05619 19.6464 8.15621C19.5527 8.25623 19.5 8.39188 19.5 8.53333V11.7333C19.5 11.8748 19.5527 12.0104 19.6464 12.1105C19.7402 12.2105 19.8674 12.2667 20 12.2667Z",
    fill: "#8898A6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 10.1328H18.4999V11.1995H13.5V10.1328Z",
    fill: "#8898A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSolidIcon);
export default __webpack_public_path__ + "static/media/calendar-solid-icon.a2c6930245272f6895436ef51e68907c.svg";
export { ForwardRef as ReactComponent };